module.exports = __webpack_public_path__ + "static/img/11.40b1c17.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/11.png
// module id = RWy+
// module chunks = 0